<template>
    <div>
        <page-title>模版编辑</page-title>
        <page-body>
            <el-form v-loading="loading" :model="form" :rules="rules" ref="form">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="form.name" placeholder="模版名称"/>
                </el-form-item>
                <el-form-item label="上架状态" prop="status">
                    <el-radio-group v-model="form.status" :disabled="form.approval_status !== 1">
                        <el-radio :label="0">已下架</el-radio>
                        <el-radio :label="1">已上架</el-radio>
                    </el-radio-group>
                    <template v-if="form.approval_status !== 1">
                        <br>
                        <span>模版需要先审核通过才可以上架</span>
                        <el-button type="text" @click="showTemplateApprovalDialog = true">点击审核</el-button>
                    </template>
                </el-form-item>
                <el-form-item label="模版类型" prop="type">
                    <el-radio-group v-model="form.type" :disabled="form.id > 0 && !enabledTypeEdit">
                        <el-radio label="home">首页</el-radio>
                        <el-radio label="diy">DIY</el-radio>
                    </el-radio-group>
                    <el-button @click="enabledTypeEdit = !enabledTypeEdit" type="text" style="margin-left: 20px">{{enabledTypeEdit?'锁定':'修改类型'}}</el-button>
                </el-form-item>
                <el-form-item label="应用范围" prop="range">
                    <el-checkbox-group v-model="form.range" size="mini">
                        <el-checkbox label="page" size="mini">微页面</el-checkbox>
                        <el-checkbox label="module" size="mini">自定义模块</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="售价" prop="price">
                    <el-input v-model="form.price" type="number" min="0" max="100000" step="0.01"></el-input>
                </el-form-item>
                <el-form-item label="图片" prop="pics">
                    <app-upload :multiple="true" :preview="true" v-model="form.pics"></app-upload>
                </el-form-item>
                <el-form-item label="模版包" prop="package">
                    <uploader v-model="form.package"></uploader>
                </el-form-item>
                <el-form-item label="所需DIY最低版本" prop="require_diy_version">
                    <el-input v-model="form.require_diy_version"></el-input>
                </el-form-item>
                <el-form-item label="详情" prop="detail">
                    <br>
                    <quill-editor :options="editorOption" v-model="form.detail"></quill-editor>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" @click="submit('form')" type="primary">{{form.id ? '保存' : '添加'}}
                    </el-button>
                </el-form-item>
            </el-form>
        </page-body>

        <el-dialog
                title="模版审核"
                :visible.sync="showTemplateApprovalDialog" :close-on-click-modal="false">
            <el-form>
                <el-form-item label="审核状态">
                    <el-radio :label="1" v-model="templateApprovalForm.approval_status">通过</el-radio>
                    <el-radio :label="2" v-model="templateApprovalForm.approval_status">不通过</el-radio>
                </el-form-item>
                <el-form-item label="审核结果">
                    <el-input type="textarea" v-model="templateApprovalForm.approval_result"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="showTemplateApprovalDialog = false">取消</el-button>
                    <el-button type="primary" :loading="templateApprovalLoading" @click="templateApprovalSubmit">提交
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import baseUrl from '@/base-url'
import axios from '@/axios'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
import {quillRedefine} from 'vue-quill-editor-upload'
import uploader from '@/components/Uploader'

export default {
    components: {
        quillEditor,
        uploader
    },
    data() {
        return {
            // uploadServer: baseUrl + "/admin/upload/file",
            // uploadHeaders: null,
            enabledTypeEdit: false,
            showTemplateApprovalDialog: false,
            templateApprovalLoading: false,
            loading: false,
            btnLoading: false,
            detail: null,
            rules: {
                name: [
                    {required: true, message: '请填插件标识。'}
                ],
                display_name: [
                    {required: true, message: '请填插件名称。'}
                ],
                package: [
                    {required: true, message: '请上传模版包。'}
                ],
                pics: [
                    {required: true, message: '请上传预览图。'}
                ],
                price: [
                    {required: true, message: '请填写售价。'}
                ],
                type: [
                    {required: true, message: '请选择模版类型。'}
                ],
                range: [
                    {required: true, message: '请选择应用范围。'}
                ]
            },
            form: {
                id: null,
                name: '',
                pics: [],
                package: '',
                detail: '',
                status: 0,
                approval_status: 0,
                price: 0,
                type: 'home',
                require_diy_version: '',
                range: []
            },
            templateApprovalForm: {
                id: 0,
                approval_status: 0,
                approval_result: ''
            },
            editorOption: {}
        }
    },
    created() {
        this.editorOption = quillRedefine(
            {
                // 图片上传的设置
                uploadConfig: {
                    // 必填参数 图片上传地址
                    action: baseUrl + '/admin/upload/file',
                    header: (xhr, formData) => {
                        xhr.setRequestHeader('Access-Token', this.$store.state.user.access_token)
                    },
                    name: 'file',
                    // 必选参数  res是一个函数，函数接收的response为上传成功时服务器返回的数据
                    // 你必须把返回的数据中所包含的图片地址 return 回去
                    res: (response) => {
                        // 这里切记要return回你的图片地址
                        if (response.code === 0) {
                            return response.data.url
                        }
                    }
                }
            }
        )
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id
            this.loadData()
        }
    },
    methods: {
        loadData() {
            this.loading = true
            axios({
                url: 'admin/template/detail',
                params: {
                    id: this.form.id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.form = e.data.data
                    this.templateApprovalForm.id = this.form.id
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    axios({
                        url: this.form.id ? 'admin/template/update' : 'admin/template/create',
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.btnLoading = false
                        if (e.data.code === 0) {
                            this.$message.success('保存成功。')
                            this.$router.push('/dashboard/admin/template/index')
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                }
            })
        },
        templateApprovalSubmit() {
            this.templateApprovalLoading = true
            axios({
                url: 'admin/template/approval-submit',
                method: 'post',
                data: this.templateApprovalForm
            }).then(e => {
                if (e.data.code === 0) {
                    this.$message.success(e.data.msg)
                    this.showTemplateApprovalDialog = false
                    this.form.approval_status = this.templateApprovalForm.approval_status
                } else {
                    this.templateApprovalLoading = false
                    this.$message.error(e.data.msg)
                }
            })
        }
    }
}
</script>
